import React, { useState } from "react";
import SubjectTabs from "../../../components/common/SubjectTabs";
import MyAdmins from "../../../components/ui/MyAdmins";
import { AddNewAdmin } from "../../../components/ui/AddNewAdmin";

const CreateAdminUserPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="min-h-[calc(100%-theme(space.2))] bg-myLight pb-4">
      <section className="border-b border-myInputBorder/60 bg-transparent backdrop-blur-md w-full sticky z-30 top-0 p-4">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="md:text-2xl sm:text-xl lext-lg font-bold text-myLabelText capitalize">
            Admin Users
          </h1>
        </div>
      </section>
      <section className="max-w-5xl mx-auto px-4 ">
        <SubjectTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={[
            {
              label: "Active admin",
              content: <MyAdmins />,
            },
            {
              label: "Add new admin",
              content: <AddNewAdmin onEnrollSuccess={() => setActiveTab(0)} />,
            },
          ]}
        />
      </section>
    </div>
  );
};

export default CreateAdminUserPage;